import { IPagination } from '../../../../../models/pagination.model';

export interface IAppearanceConfigurationsInterface {
  pagination: IPagination
}

export const initialAppearanceConfigurationsState: IAppearanceConfigurationsInterface = {
  pagination: null
};
